export default class Tag{
  constructor(node) {
    this._name = node.getAttribute("name");
    this._value = node.getAttribute("value");
  }

  name() {
    return this._name;
  }

  value() {
    return this._value;
  }
}